module.exports = __webpack_public_path__ + "img/settings-example.650a8487.gif";